import React, { memo } from 'react';
import { Modal, Text } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../../lib/Web5Context";
const ModalSaveBeforeLeave = /*#__PURE__*/memo(_ref => {
  let {
    isOpen,
    onCancel,
    onConfirm
  } = _ref;
  const {
    t
  } = useWeb5Context();
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    size: "small",
    title: t('label_unsaved_filters'),
    confirmText: t('action_save_changes'),
    cancelText: t('action_discard_changes'),
    onCancel: onCancel,
    onConfirm: onConfirm,
    useCornerClose: false
  }, /*#__PURE__*/React.createElement(Text, null, t('label_unsaved_forcebi_dashboard_filters')));
});
export default ModalSaveBeforeLeave;